import React, {FC} from 'react';
import {CustomButton, ICustomButton} from "../../UI/AntCustom/CustomButton";
import ChatIcon from "../../../media/icons/chat_black.svg?react";
import styled from "styled-components";

const ChatNotificationDot = styled.div`
  position: absolute;
  top: 5px;
  right: 13px;
  height: 10px;
  width: 10px;
  background: #1890FF;
  border-radius: 100%;
`;

interface IChatButton extends Omit<ICustomButton, "children"> {
  hasNewMessages: boolean;
}

export const ChatButton: FC<IChatButton> = (props) => {
  const {hasNewMessages, ...otherProps} = props;

  return (
    <CustomButton heightSize={'m'} {...otherProps}>
      <ChatIcon />
      {hasNewMessages && <ChatNotificationDot />}
    </CustomButton>
  );
};
